<ion-content class="splash-content">
  <div class="splash-overlay">
    <div class="splash-container">
      <img src="assets/images/just_canoe_globe.png" alt="Gnok News Logo" class="splash-logo">
      <h1 class="app-title">EZ Knews</h1>
      <h2 class="slogan">{{ 'SPLASH.SLOGAN' | translate }}</h2>
      <p class="description">
        {{ 'SPLASH.DESCRIPTION' | translate }}
      </p>
      <ion-button expand="block" class="cta-button" (click)="startAsGuest()">
        {{ 'SPLASH.GET_STARTED' | translate }}
      </ion-button>
    </div>
  </div>
</ion-content>